
// //  Appear Down
// import React, { useState, useEffect, useRef } from "react";
// import Slide from "@mui/material/Slide";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import { useNavigate } from "react-router-dom";
// import { keyframes } from "@mui/system";
// import { useTheme } from "@mui/material/styles";

// // ✅ Icons
// import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
// import AssessmentIcon from '@mui/icons-material/Assessment';
// import QueryStatsIcon from '@mui/icons-material/QueryStats';
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";


// // ✅ Reuse stable navigation
// function useStableNavigate() {
//   const navigate = useNavigate();
//   const navigateRef = useRef(navigate);

//   useEffect(() => {
//     navigateRef.current = navigate;
//   }, [navigate]);

//   return () => navigateRef.current;
// }

// // 🟢 Bounce animation (from bottom)
// const bounceFromBottom = keyframes`
//   0% { transform: translateY(150%); opacity: 0; }
//   40% { transform: translateY(-20px); opacity: 1; }
//   65% { transform: translateY(8px); }
//   85% { transform: translateY(-4px); }
//   100% { transform: translateY(0); }
// `;

// function SocialPopup({ selectedProfiles, onDeleteConfirm }) {
//   const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [hasAnimatedIn, setHasAnimatedIn] = useState(false);
//   const getNavigate = useStableNavigate();
//   const theme = useTheme();

//   // ✅ Control when bounce animation runs
//   useEffect(() => {
//     if (selectedProfiles.length > 0 && !hasAnimatedIn) {
//       setHasAnimatedIn(true);
//     } else if (selectedProfiles.length === 0) {
//       setHasAnimatedIn(false);
//     }
//   }, [selectedProfiles.length, hasAnimatedIn]);

//   const handleDeleteClick = () => setIsConfirmDialogOpen(true);

//   const handleConfirmDelete = async () => {
//     setIsConfirmDialogOpen(false);
//     onDeleteConfirm();
//   };

//   const handleGenerateReports = () => {
//     if (selectedProfiles.length > 0) {
//       console.log("Navigating to Insight Hub with profiles:", selectedProfiles);
//       getNavigate()("/insight-hub", { state: { selectedProfiles } });
//     } else {
//       console.error("Please select at least one profile to generate the report.");
//     }
//   };

//   return (
//     <>
//       {/* Slide-in Bottom Panel */}
//       <Slide direction="up" in={selectedProfiles.length > 0} mountOnEnter unmountOnExit>
//         <MDBox
//           sx={{
//             position: "fixed",
//             bottom: 0,
//             left: 0,
//             width: "100%",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "16px 24px",
//             zIndex: 1300,
//             borderTop: "4px solid #00A1A1", // 🟢 Teal border (matches style)
//             backgroundColor: theme.functions.rgba("#dee2e6", 0.5), // 🟢 Transparent frosted look
//             backdropFilter: `saturate(200%) blur(30px)`,
//             boxShadow: "0 -3px 12px rgba(0,0,0,0.15)",
//             animation: hasAnimatedIn
//               ? `${bounceFromBottom} 0.7s cubic-bezier(0.34, 1.56, 0.64, 1)`
//               : "none", // 🟢 Bounce animation
//           }}
//         >
//           <Typography variant="h6">
//             {selectedProfiles.length} Profile
//             {selectedProfiles.length > 1 ? "s" : ""} Selected
//           </Typography>

//           {/* Main Actions */}
//           <MDBox
//             display="flex"
//             flexDirection={{ xs: "column", sm: "row" }} // 🟢 Stack on mobile, row on desktop
//             gap={1.5}
//             sx={{
//               mr: { xs: 8, sm: 8, md: 10 },
//               justifyContent: { sm: "flex-end" },
//               alignItems: { xs: "stretch", sm: "center" },
//             }}
//           >
//             <MDButton
//               variant="contained"
//               color="accent"
//               onClick={handleGenerateReports}
//               startIcon={<QueryStatsIcon />}
//               sx={{
//                 fontWeight: 500,
//                 px: { xs: 2.5, sm: 4 },
//                 minWidth: { xs: "100%", sm: "190px" }, // 🟢 Full width on mobile
//                 whiteSpace: "nowrap",
//                 textAlign: "center",
//               }}
//             >
//               Generate Reports
//             </MDButton>

//             <MDButton
//               variant="outlined"
//               color="error"
//               onClick={handleDeleteClick}
//               disabled={isDeleting}
//               startIcon={<DeleteOutlineOutlinedIcon />}
//               sx={{
//                 borderWidth: "2px",
//                 px: { xs: 2.5, sm: 4 },
//                 minWidth: { xs: "100%", sm: "160px" },
//                 whiteSpace: "nowrap",
//                 "&:hover": { borderWidth: "2px" },
//               }}
//             >
//               {isDeleting
//                 ? "Deleting..."
//                 : selectedProfiles.length === 1
//                 ? "Delete Profile"
//                 : "Delete Profiles"}
//             </MDButton>
//           </MDBox>

//         </MDBox>
//       </Slide>

//       {/* Confirmation Dialog */}
//       <Dialog open={isConfirmDialogOpen} onClose={() => setIsConfirmDialogOpen(false)}>
//         <DialogTitle>Confirm Deletion</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete{" "}
//             {selectedProfiles.length === 1
//               ? "this selected profile"
//               : `${selectedProfiles.length} selected profiles`}
//             ?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setIsConfirmDialogOpen(false)} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleConfirmDelete} color="error">
//             Confirm Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }

// export default SocialPopup;

// ######################################################


// //  Appear Down - Small centred Popup

// import React, { useState, useEffect, useRef } from "react";
// import Slide from "@mui/material/Slide";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import { useNavigate } from "react-router-dom";
// import { keyframes } from "@mui/system";
// import { useTheme } from "@mui/material/styles";

// // ✅ Icons
// import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
// import AssessmentIcon from '@mui/icons-material/Assessment';
// import QueryStatsIcon from '@mui/icons-material/QueryStats';
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";


// // ✅ Reuse stable navigation
// function useStableNavigate() {
//   const navigate = useNavigate();
//   const navigateRef = useRef(navigate);

//   useEffect(() => {
//     navigateRef.current = navigate;
//   }, [navigate]);

//   return () => navigateRef.current;
// }

// // 🟢 Bounce animation (from bottom) - Includes translateX(-50%) for stable centering.
// const bounceFromBottom = keyframes`
//   0% { transform: translateX(-50%) translateY(150%); opacity: 0; }
//   40% { transform: translateX(-50%) translateY(-20px); opacity: 1; }
//   65% { transform: translateX(-50%) translateY(8px); }
//   85% { transform: translateX(-50%) translateY(-4px); }
//   100% { transform: translateX(-50%) translateY(0); }
// `;

// function SocialPopup({ selectedProfiles, onDeleteConfirm }) {
//   const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [hasAnimatedIn, setHasAnimatedIn] = useState(false);
//   const getNavigate = useStableNavigate();
//   const theme = useTheme();

//   // Note: The isSidenavMini prop and dynamic width calculation are removed here
//   // to revert to screen-centered positioning.

//   // ✅ Control when bounce animation runs
//   useEffect(() => {
//     if (selectedProfiles.length > 0 && !hasAnimatedIn) {
//       setHasAnimatedIn(true);
//     } else if (selectedProfiles.length === 0) {
//       setHasAnimatedIn(false);
//     }
//   }, [selectedProfiles.length, hasAnimatedIn]);

//   const handleDeleteClick = () => setIsConfirmDialogOpen(true);

//   const handleConfirmDelete = async () => {
//     setIsConfirmDialogOpen(false);
//     onDeleteConfirm();
//   };

//   const handleGenerateReports = () => {
//     if (selectedProfiles.length > 0) {
//       console.log("Navigating to Insight Hub with profiles:", selectedProfiles);
//       getNavigate()("/insight-hub", { state: { selectedProfiles } });
//     } else {
//       console.error("Please select at least one profile to generate the report.");
//     }
//   };

//   return (
//     <>
//       {/* Slide-in Bottom Panel */}
//     <Slide direction="up" in={selectedProfiles.length > 0} mountOnEnter unmountOnExit>
//       <MDBox
//         sx={{
//           // Centering and Width Adjustments (Screen Centered)
//           position: "fixed",
//           bottom: 10,
//           left: "50%", // Screen center
//           transform: "translateX(-50%)", // Shift left by 50% of its own width
//           width: "95%",
//           maxWidth: "800px",

//           // Design/Height Adjustments
//           display: "flex",
//           justifyContent: "space-between", // Keep label left, buttons right
//           alignItems: "center",
//           padding: "12px 24px",
//           borderRadius: "12px",

//           zIndex: 1300,
//           border: "2px solid #00A1A1",
//           backgroundColor: theme.functions.rgba("#000", 0.5),
//           backdropFilter: `saturate(200%) blur(30px)`,
//           boxShadow: "0 -3px 12px rgba(0,0,0,0.15)",
//           animation: hasAnimatedIn
//             ? `${bounceFromBottom} 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) forwards` // Added 'forwards' to ensure final state is held
//             : "none",
//         }}
//       >
//         <Typography variant="h6" color="#fff">
//           {selectedProfiles.length} Profile
//           {selectedProfiles.length > 1 ? "s" : ""} Selected
//         </Typography>

//         {/* Main Actions */}
//         <MDBox
//           display="flex"
//           flexDirection={{ xs: "column", sm: "row" }}
//           gap={1.5}
//           sx={{
//             // FIX: Removed unnecessary large right margin to allow buttons to sit correctly on the right edge.
//             mr: { xs: 0, sm: 0, xl: 0 }, 
//             justifyContent: { sm: "flex-end" },
//             alignItems: { xs: "stretch", sm: "center" },
//           }}
//         >
//           <MDButton
//             variant="contained"
//             color="accent"
//             onClick={handleGenerateReports}
//             startIcon={<QueryStatsIcon />}
//             sx={{
//               fontWeight: 500,
//               px: { xs: 2.5, sm: 4 },
//               minWidth: { xs: "100%", sm: "190px" },
//               whiteSpace: "nowrap",
//               textAlign: "center",
//             }}
//           >
//             Generate Reports
//           </MDButton>

//           <MDButton
//             variant="contained"
//             color="error"
//             onClick={handleDeleteClick}
//             disabled={isDeleting}
//             startIcon={<DeleteOutlineOutlinedIcon />}
//             sx={{
//               borderWidth: "2px",
//               px: { xs: 2.5, sm: 4 },
//               minWidth: { xs: "100%", sm: "160px" },
//               whiteSpace: "nowrap",
//               "&:hover": { borderWidth: "2px" },
//             }}
//           >
//             {isDeleting
//               ? "Deleting..."
//               : selectedProfiles.length === 1
//               ? "Delete Profile"
//               : "Delete Profiles"}
//           </MDButton>
//         </MDBox>
//       </MDBox>
//     </Slide>


//       {/* Confirmation Dialog */}
//       <Dialog open={isConfirmDialogOpen} onClose={() => setIsConfirmDialogOpen(false)}>
//         <DialogTitle>Confirm Deletion</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete{" "}
//             {selectedProfiles.length === 1
//               ? "this selected profile"
//               : `${selectedProfiles.length} selected profiles`}
//             ?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setIsConfirmDialogOpen(false)} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleConfirmDelete} color="error">
//             Confirm Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }

// export default SocialPopup;

// ##################################################

// Appear Down Small with restriction

//  Appear Down - Small centred Popup

import React, { useState, useEffect, useRef } from "react";
import Slide from "@mui/material/Slide";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Snackbar from "@mui/material/Snackbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { keyframes } from "@mui/system";
import { useTheme } from "@mui/material/styles";

// ✅ Icons
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import TouchAppIcon from "@mui/icons-material/TouchApp";

import WorkspaceService from "services/workspace-service";

import UpgradePopup from "layouts/components/Upgrade";
import { usePermissions } from "context";
import LiveDemoRestriction from "layouts/components/Upgrade/liveDemo"; // [NEW]

// ✅ Reuse stable navigation
function useStableNavigate() {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);

  useEffect(() => {
    navigateRef.current = navigate;
  }, [navigate]);

  return () => navigateRef.current;
}

// 🟢 Bounce animation (from bottom)
const bounceFromBottom = keyframes`
  0% { transform: translateX(-50%) translateY(150%); opacity: 0; }
  40% { transform: translateX(-50%) translateY(-20px); opacity: 1; }
  65% { transform: translateX(-50%) translateY(8px); }
  85% { transform: translateX(-50%) translateY(-4px); }
  100% { transform: translateX(-50%) translateY(0); }
`;

function SocialPopup({ selectedProfiles, onDeleteConfirm, enableReportGeneration = true, demoMode = false, onDemoAnalyze = null }) {
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [hasAnimatedIn, setHasAnimatedIn] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "" }); // ✅ Added Snackbar
  const getNavigate = useStableNavigate();
  const theme = useTheme();

  const [usageRaw, setUsageRaw] = useState(null);
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [upgradeMessage, setUpgradeMessage] = useState(""); // [NEW] Custom message
  const [showDemoPopup, setShowDemoPopup] = useState(false); // [NEW] Demo Popup State

  // [NEW] RBAC State
  const [showRBAC, setShowRBAC] = useState(false);
  const [rbacFeature, setRbacFeature] = useState("");
  const [rbacRole, setRbacRole] = useState("");

  const { hasPermission, requiredRoles } = usePermissions();

  // [NEW] Fetch Usage Logic
  useEffect(() => {
    const fetchUsageData = async () => {
      if (selectedProfiles.length === 0) return; // Don't fetch if nothing selected

      try {
        const entitlements = await WorkspaceService.fetchWorkspaceEntitlements();
        if (!entitlements) return;

        setUsageRaw({
          swapsUsed: entitlements.usage?.profile_swaps || 0,
          swapsLimit: entitlements.limits?.profile_swaps || 0,
          currentPlan: entitlements.plan || "Basic"
        });
      } catch (error) {
        console.error("Error fetching usage details:", error);
      }
    };
    fetchUsageData();
  }, [selectedProfiles.length]);

  const MAX_SELECTION = 4; // ✅ Restrict maximum selection for reports

  useEffect(() => {
    if (selectedProfiles.length > 0 && !hasAnimatedIn) {
      setHasAnimatedIn(true);
    } else if (selectedProfiles.length === 0) {
      setHasAnimatedIn(false);
    }
  }, [selectedProfiles.length, hasAnimatedIn]);

  const handleDeleteClick = () => {
    // [NEW] Live Demo Restriction
    const isDemo = sessionStorage.getItem('demo_role_cache') === "demo_viewer";
    if (isDemo) {
      setShowDemoPopup(true);
      return;
    }

    // [NEW] Check Usage Limit
    if (usageRaw) {
      const { swapsUsed, swapsLimit } = usageRaw;
      const totalSwaps = Number(swapsUsed) + selectedProfiles.length;
      console.log(`[SocialPopup] Checking Limits: Used=${swapsUsed}, Limit=${swapsLimit}, Selected=${selectedProfiles.length}, Total=${totalSwaps}`);

      if (totalSwaps > Number(swapsLimit)) {
        console.warn("[SocialPopup] Limit Exceeded! Showing Upgrade Popup.");

        if (selectedProfiles.length > 1) {
          setUpgradeMessage(`This action requires <strong>${totalSwaps}</strong> total profile swaps (${swapsUsed} used + ${selectedProfiles.length} selected), which exceeds your limit of <strong>${swapsLimit}</strong>.`);
        } else {
          setUpgradeMessage(""); // Use default message for single profile
        }

        setShowUpgrade(true);
        return;
      }
      // [NEW] RBAC Check
      if (!hasPermission("stash:manage")) {
        setRbacFeature("Deleting Profiles");
        setRbacRole(requiredRoles["stash:manage"] || "Manager");
        setShowRBAC(true);
        return;
      }

      setUpgradeMessage(""); // Reset message for normal flows or cancellations
      setIsConfirmDialogOpen(true);
    }
  };

  const handleConfirmDelete = async () => {
    setIsConfirmDialogOpen(false);
    onDeleteConfirm();
  };

  const handleGenerateReports = () => {
    if (selectedProfiles.length === 0) {
      setSnackbar({ open: true, message: "⚠️ Please select at least one profile to analyse profile." });
      return;
    }

    // ✅ Apply restriction here
    if (selectedProfiles.length > MAX_SELECTION) {
      setSnackbar({ open: true, message: `⚠️ You can select up to ${MAX_SELECTION} profiles only.` });
      return;
    }

    if (onDemoAnalyze) {
      onDemoAnalyze();
    }

    // [NEW] RBAC Check
    if (!hasPermission("reports:view")) {
      setRbacFeature("Analysing profiles");
      setRbacRole(requiredRoles["reports:view"] || "Viewer");
      setShowRBAC(true);
      return;
    }

    // console.log("Navigating to Insight Hub with profiles:", selectedProfiles);
    getNavigate()("/insight-hub", { state: { selectedProfiles } });
  };

  return (
    <>
      {/* Slide-in Bottom Panel */}
      <Slide direction="up" in={selectedProfiles.length > 0} mountOnEnter unmountOnExit>
        <MDBox
          sx={{
            position: "fixed",
            bottom: 10,
            left: "50%",
            transform: "translateX(-50%)",
            width: "95%",
            maxWidth: "800px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 24px",
            borderRadius: "12px",
            zIndex: 1300,
            border: "2px solid #00A1A1",
            backgroundColor: theme.functions.rgba("#000", 0.5),
            backdropFilter: `saturate(200%) blur(30px)`,
            boxShadow: "0 -3px 12px rgba(0,0,0,0.15)",
            animation: hasAnimatedIn
              ? `${bounceFromBottom} 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) forwards`
              : "none",
          }}
        >
          <Typography variant="h6" color="#fff">
            {selectedProfiles.length} Profile
            {selectedProfiles.length > 1 ? "s" : ""} Selected
          </Typography>

          <MDBox
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            gap={1.5}
            sx={{
              mr: { xs: 0, sm: 0, xl: 0 },
              justifyContent: { sm: "flex-end" },
              alignItems: { xs: "stretch", sm: "center" },
            }}
          >
            {enableReportGeneration && (
              <MDBox position="relative"> {/* Wrap in relative box for tooltip */}
                {demoMode && (
                  <MDBox
                    position="absolute"
                    top="-64px"
                    left="50%"
                    sx={{
                      transform: "translateX(-50%)",
                      width: "max-content",
                      zIndex: 1400,
                      animation: "bob 2s infinite ease-in-out"
                    }}
                  >
                    <style>
                      {`
                        @keyframes bob {
                          0%, 100% { transform: translateX(-50%) translateY(0); }
                          50% { transform: translateX(-50%) translateY(-10px); }
                        }
                      `}
                    </style>
                    <MDBox
                      variant="gradient"
                      bgColor="dark"
                      borderRadius="lg"
                      coloredShadow="dark"
                      px={2}
                      py={1}
                      position="relative"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <MDBox
                        width="24px"
                        height="24px"
                        borderRadius="50%"
                        bgColor="accent" // Orange
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        opacity={1}
                      >
                        <TouchAppIcon fontSize="small" sx={{ color: "black !important", fontSize: "16px !important", transform: "rotate(180deg)" }} />
                      </MDBox>
                      <MDTypography variant="caption" color="white" fontWeight="bold">
                        Click to Analyse
                      </MDTypography>
                      {/* Arrow */}
                      <MDBox
                        position="absolute"
                        bottom="-6px"
                        left="50%"
                        sx={{
                          width: 0,
                          height: 0,
                          borderLeft: "8px solid transparent",
                          borderRight: "8px solid transparent",
                          borderTop: "8px solid #191919",
                          transform: "translateX(-50%)",
                        }}
                      />
                    </MDBox>
                  </MDBox>
                )}
                <MDButton
                  variant="contained"
                  color="accent"
                  onClick={handleGenerateReports}
                  startIcon={<QueryStatsIcon />}
                  sx={{
                    fontWeight: 500,
                    px: { xs: 2.5, sm: 4 },
                    minWidth: { xs: "100%", sm: "190px" },
                    whiteSpace: "nowrap",
                    textAlign: "center",
                    position: demoMode ? "relative" : "initial",
                    zIndex: demoMode ? 1350 : "auto", // High z-index for demo
                    boxShadow: demoMode ? "0 0 20px #00A1A1" : undefined, // Glow effect
                    border: demoMode ? "2px solid #fff" : undefined,
                  }}
                >
                  {selectedProfiles.length === 1 ? "Analyse Profile" : "Analyse Profiles"}
                </MDButton>
              </MDBox>
            )}
            {/* [NEW] Show Delete Button as is, click handled for RBAC */}
            {sessionStorage.getItem('demo_role_cache') !== "demo_viewer" && (
              <MDButton
                variant="contained"
                color="error"
                onClick={handleDeleteClick}
                disabled={isDeleting}
                startIcon={<DeleteOutlineOutlinedIcon />}
                sx={{
                  borderWidth: "2px",
                  px: { xs: 2.5, sm: 4 },
                  minWidth: { xs: "100%", sm: "160px" },
                  whiteSpace: "nowrap",
                  "&:hover": { borderWidth: "2px" },
                }}
              >
                {isDeleting
                  ? "Deleting..."
                  : selectedProfiles.length === 1
                    ? "Delete Profile"
                    : "Delete Profiles"}
              </MDButton>
            )}
          </MDBox>
        </MDBox>
      </Slide>

      {/* Confirmation Dialog */}
      <Dialog open={isConfirmDialogOpen} onClose={() => setIsConfirmDialogOpen(false)}
        sx={{
          zIndex: (theme) => theme.zIndex.modal + 2000,   // ⬅ Force to front
        }}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete{" "}
            {selectedProfiles.length === 1
              ? "this selected profile"
              : `${selectedProfiles.length} selected profiles`}
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsConfirmDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Confirm Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{ bottom: "80px" }} // Moves snackbar slightly above bottom panel
        ContentProps={{
          sx: { borderRadius: 2, boxShadow: 3, mb: 6 },
        }}
      />

      {/* [NEW] Upgrade Popup */}
      <UpgradePopup
        open={showUpgrade}
        onClose={() => setShowUpgrade(false)}
        type="usage"
        featureName="Profile Swaps"
        planRequired="Higher Plan"
        currentPlan={usageRaw?.currentPlan}
        usageLimit={usageRaw?.swapsLimit}
        unit="profile swaps"
        message={upgradeMessage}
      />

      {/* [NEW] Live Demo Restriction Popup */}
      <LiveDemoRestriction
        open={showDemoPopup}
        onClose={() => setShowDemoPopup(false)}
        featureName="Deleting Profile"
      />

      {/* [NEW] RBAC Restriction Popup */}
      <UpgradePopup
        open={showRBAC}
        onClose={() => setShowRBAC(false)}
        type="rbac"
        featureName={rbacFeature}
        roleRequired={rbacRole}
      />
    </>
  );
}

export default SocialPopup;
